import { createStore, createEvent } from 'effector';

const searchStore = createStore<string>('');
const changeSearch = createEvent<string>();

searchStore.on(changeSearch, (_, value: string) => value);

export { searchStore, changeSearch };
